import { twMerge } from "tailwind-merge";
import { useCatalog } from "./Catalog.context";

export default function CatalogContainer({ children }) {
  const { isResponsive } = useCatalog();

  return (
    <div
      className={twMerge(
        "relative flex h-screen w-full items-center justify-center overflow-hidden bg-black",
        isResponsive && "block h-auto min-h-screen overflow-y-auto overflow-x-hidden bg-white",
      )}
    >
      {children}
    </div>
  );
}
